"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayBase64DecodeTemplate = StringArrayBase64DecodeTemplate;
function StringArrayBase64DecodeTemplate(randomGenerator) {
    const identifierLength = 6;
    const initializedIdentifier = randomGenerator.getRandomString(identifierLength);
    const base64Identifier = randomGenerator.getRandomString(identifierLength);
    const dataIdentifier = randomGenerator.getRandomString(identifierLength);
    const cacheStateIdentifier = randomGenerator.getRandomString(identifierLength);
    return `
        if ({stringArrayCallsWrapperName}.${initializedIdentifier} === undefined) {
            {atobPolyfill}
            {stringArrayCallsWrapperName}.${base64Identifier} = {atobFunctionName};

            {stringArrayCallsWrapperName}.${dataIdentifier} = {};

            {stringArrayCallsWrapperName}.${initializedIdentifier} = true;
        }

        const firstValue = stringArray[0];

        if ({stringArrayCallsWrapperName}.${cacheStateIdentifier} !== firstValue) {
            {stringArrayCallsWrapperName}.${dataIdentifier} = {};
            {stringArrayCallsWrapperName}.${cacheStateIdentifier} = firstValue;
        }

        const cachedValue = {stringArrayCallsWrapperName}.${dataIdentifier}[index];

        if (cachedValue === undefined) {
            {selfDefendingCode}

            value = {stringArrayCallsWrapperName}.${base64Identifier}(value);
            {stringArrayCallsWrapperName}.${dataIdentifier}[index] = value;
        } else {
            value = cachedValue;
        }
    `;
}
